import { createAction } from "redux-starter-kit";
import { CLOSE_EDIT_LINEITEM } from "../types";

const closeEditLineItem = () => createAction(CLOSE_EDIT_LINEITEM)();

export default closeEditLineItem;
